<template>
    <div>
        <el-table :data="tableData">
            <el-table-column prop="category" width="200px" label="Категорія">
            </el-table-column>
            <el-table-column prop="rule" label="Правило">
            </el-table-column>
            <el-table-column label="Дії" width="150px">
                <template slot-scope="scope">
                    <el-button
                    icon="el-icon-edit"
                    @click="handleEdit(scope.row)"></el-button>
                    <el-button
                    type="danger"
                    icon="el-icon-delete"
                    @click="handleDelete(scope.$index, tableData, scope.row.id)"></el-button>
                </template>
                </el-table-column>
        </el-table>

    </div>
</template>

<script>
  export default {
    name: "CategoryRulesTable",
    props: ['tableData'],
  }

</script>

<style scoped>

</style>